/**
 *
 * PortalTextField
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 10-Nov-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField } from '@mui/material';
import { generateUniqueId } from 'Utility/generateUniqueID';
import style from './PortalTextField.scss';

const PortalTextField = (props) => (
	<Grid className={`${style.container} ${props.showIcon !== '' ? style.withIcon : ''}`}>
		<TextField
			key={props.name}
			id={props.name}
			name={props.name}
			type={props.type}
			label={props.label}
			onBlur={props.onBlur}
			onChange={props.onChange}
			value={props.value}
			error={props.error}
			placeholder={props.placeholder}
			helperText={props.errorMessage}
			{...props}
		/>
		{props.showIcon !== '' && <i className={`${props.showIcon} ${props.disabled ? style.iconDisabled : ''}`} />}
	</Grid>
);

PortalTextField.propTypes = {
	name: PropTypes.string,
	type: PropTypes.oneOf(['email', 'password', 'tel', 'text', 'number', 'date']),
	label: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	error: PropTypes.bool,
	disabled: PropTypes.bool,
	showIcon: PropTypes.string,
	errorMessage: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.exact({
			id: PropTypes.string,
		}),
	]),
	placeholder: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.exact({
			id: PropTypes.string,
		}),
	]),
};

PortalTextField.defaultProps = {
	type: 'text',
	errorMessage: '',
	name: generateUniqueId(),
	label: '',
	disabled: false,
	showIcon: '',
	onChange: () => {},
};

export default PortalTextField;
